import { Box } from "theme-ui"
export const Tabs: React.FC<TabsProps> = ({ items, value, onChange }) => {
 return (
  <Box bg="body_gray">
   <div className={`flex bg-gray w-[30%]`}>
    {items?.map((item, index) => (
     <div
      key={index}
      className={` px-2 py-2 cursor-pointer ${item.key === value ? "bg-white rounded  text-black " : ""}`}
      onClick={() => onChange(item?.key)}
     >
      {item?.label}
     </div>
    ))}
   </div>
   {items?.map((x) => x.key === value && x?.children)}
  </Box>
 )
}

interface TabsProps {
 items: {
  key: string
  label: string
  children: React.ReactNode
 }[]
 value: string
 onChange: (_key: string) => void
}
